import React from 'react';
import { Loading } from 'components/shared/Loading';
import { BusyIndicatorSize } from '@ui5/webcomponents-react';
import { AuthenticationErrorPage } from 'components/shared/AuthenticationErrorPage';
import '@ui5/webcomponents-icons/dist/message-warning';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { interactionType, loginRequest } from 'auth/msalConfig';

const LoadingPage = () => <Loading size={BusyIndicatorSize.Large} />;

interface AuthProviderProps {
  children: React.ReactNode;
  pca: IPublicClientApplication;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children, pca }) => {
  const authRequest = {
    ...loginRequest
  };

  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate
        interactionType={interactionType}
        authenticationRequest={authRequest}
        errorComponent={AuthenticationErrorPage}
        loadingComponent={LoadingPage}
      >
        {children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};
